import { render, staticRenderFns } from "./dokpendukung.vue?vue&type=template&id=7cc0cfd3"
import script from "./dokpendukung.vue?vue&type=script&lang=js"
export * from "./dokpendukung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports